/* src/app/modules/dna-syngovia/components/dna-syngovia-chart-map-legend/dna-syngovia-chart-map-legend.component.scss */
:host {
  display: block;
}
.hifen--dicomConnection {
  border: 0.125rem solid var(--support-5-tint, #6CAEFF);
  width: 0.75rem;
}
.hifen--network {
  border: 0.125rem solid rgb(var(--ui-6, #C8C8C8));
  width: 0.75rem;
}
.flex-row-nowrap {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.legend-container {
  gap: calc(var(--gap) * 2);
  justify-content: center;
}
.legend-item {
  gap: calc(var(--gap) * 0.5);
  width: max-content;
  justify-content: flex-end;
}
.legend-item sh-text {
  width: fit-content;
  font-size: var(--font-size);
  color: var(--text-secondary);
  white-space: nowrap;
}
/*# sourceMappingURL=dna-syngovia-chart-map-legend.component.css.map */
